import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Travel Service */
const createTravelApplication = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.createTravelApplication}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Travel Request Service */
const getTravelRequest = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getTravelRequest}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Travel Approval Service*/
const getTravelApproval = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getTravelApproval}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};



/* Update Travel Service */
const updateTravelApplication = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.updateTravelApplication}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Delete Travel Service */
const deleteTravel = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.deleteTravel}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Add Travel Type Service */
const addTravelType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.addTravelType}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Add Travel Type Service */
const getTravelType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getTravelType}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Update Travel Type Service */
const updateTravelType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.updateTravelType}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* delete Travel Type Service */
const deleteTravelType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.deleteTravelType}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};


/* Get All Travel Type Service */
const getAllTravelType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getAllTravelType}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};


/* travel Request Approve Reject Travel Type Service */
const travelRequestApproveReject = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.travelRequestApproveReject}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Create Travel And Claim Rule Type Service */
const createTravelAndClaimRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.createTravelAndClaimRule}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Create Travel And Claim Rule Type Service */
const getTravelAndClaimRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getTravelAndClaimRule}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* update Travel And Claim Rule Type Service */
const updateTravelAndClaimRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.updateTravelAndClaimRule}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Delete Travel And Claim Rule Type Service */
const deleteTravelAndClaimRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.deleteTravelAndClaimRule}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};


/* Get All Travel And Claim Rule Type Service */
const getAllTravelAndClaimRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getAllTravelAndClaimRule}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Assign Rule Service */
const assignRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.assignRule}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Assign Rule Service */
const getAssignRule = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getAssignRule}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* get Travel Type By Id Service */
const getTravelTypeById = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getTravelTypeById}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Create Claim Service */
const createClaim = (params) => {
    const dataParam = {
        type: 'upload', // Specify upload type
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.createClaim}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Update Claim Service */
const updateClaim = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.updateClaim}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Delete Claim Service */
const deleteClaim = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.deleteClaim}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};


/* Delete Claim Service */
const getClaim = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getClaim}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Delete Claim Service */
const getClaimApproval = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getClaimApproval}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Approve Reject Claim Service */
const approveRejectClaim = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.approveRejectClaim}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Get All Travel Approval Data Service */
const getAllTravelApprovalData = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.travelAndClaim.getAllTravelApprovalData}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};
export default {
    createTravelApplication,
    getTravelRequest,
    getTravelApproval,
    updateTravelApplication,
    deleteTravel,
    addTravelType,
    getTravelType,
    updateTravelType,
    deleteTravelType,
    getAllTravelType,
    travelRequestApproveReject,
    createTravelAndClaimRule,
    getTravelAndClaimRule,
    updateTravelAndClaimRule,
    deleteTravelAndClaimRule,
    getAllTravelAndClaimRule,
    assignRule,
    getAssignRule,
    getTravelTypeById,
    createClaim,
    updateClaim,
    deleteClaim,
    getClaim,
    getClaimApproval,
    approveRejectClaim,
    getAllTravelApprovalData
}